import { IconButton, Tooltip } from "@bvhi/ui-base";
import { DeleteIcon } from "@bvhi/ui-icons";
import { useTranslation } from "react-i18next";

interface Props {
  disabled: boolean;
  handleDelete: () => void;
}

export function DeleteCell({ disabled, handleDelete }: Props) {
  const { t } = useTranslation(["common"]);
  return (
    <Tooltip title={disabled ? t("common:button.tooltip.delete.disabled") : t("common:button.tooltip.delete.enabled")}>
      <span>
        <IconButton color="error" disabled={disabled} onClick={handleDelete}>
          <DeleteIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
}
